import { Users, ChevronRight } from "lucide-react";
import "./StaffDropdown.css";

const StaffDropdown = ({ staffList = [], selectedStaffId, onSelect, language = "en", label, open, onToggle, showAnyOption = true }) => {
	const selectedStaff = staffList.find((s) => s.staffId === selectedStaffId);

	const anyLabel = language === "es" ? "Cualquier empleado" : "Any staff";
	const autoLabel = language === "es" ? "Asignado automáticamente" : "Auto-assigned";
	const slotsLabel = (n) => (language === "es" ? `${n} horarios disponibles` : `${n} slots available`);

	return (
		<div className="sf-sdd-wrap">
			{label && <h3 className="sf-sdd-label">{label}</h3>}

			<button className="sf-sdd-trigger" onClick={onToggle} type="button">
				{selectedStaffId && selectedStaff ? (
					<>
						<div className="sf-sdd-avatar">
							{selectedStaff.photo ? (
								<img src={selectedStaff.photo} alt={selectedStaff.firstName} />
							) : (
								<span>{selectedStaff.firstName?.charAt(0)}</span>
							)}
						</div>
						<span className="sf-sdd-trigger-name">
							{selectedStaff.firstName} {selectedStaff.lastName}
						</span>
					</>
				) : showAnyOption ? (
					<>
						<div className="sf-sdd-avatar sf-sdd-avatar--any">
							<Users size={16} />
						</div>
						<span className="sf-sdd-trigger-name">{anyLabel}</span>
					</>
				) : (
					<>
						<div className="sf-sdd-avatar sf-sdd-avatar--any">
							<Users size={16} />
						</div>
						<span className="sf-sdd-trigger-name" style={{ color: "#aaa" }}>
							{language === "es" ? "Seleccionar empleado" : "Select staff"}
						</span>
					</>
				)}
				<ChevronRight size={16} className={`sf-sdd-chevron${open ? " open" : ""}`} />
			</button>
			{open && (
				<div className="sf-sdd-list">
					{showAnyOption && (
            <div
                className={`sf-sdd-item${!selectedStaffId ? " active" : ""}`}
                onClick={() => onSelect("")}
            >
                <div className="sf-sdd-avatar sf-sdd-avatar--any">
                    <Users size={16} />
                </div>
                <div className="sf-sdd-info">
                    <span className="sf-sdd-name">{anyLabel}</span>
                    <span className="sf-sdd-sub">{autoLabel}</span>
                </div>
                {!selectedStaffId && <span className="sf-sdd-check">✓</span>}
            </div>
        )}

					{staffList.map((s) => (
						<div key={s.staffId} className={`sf-sdd-item${selectedStaffId === s.staffId ? " active" : ""}`} onClick={() => onSelect(s.staffId)}>
							<div className="sf-sdd-avatar">{s.photo ? <img src={s.photo} alt={s.firstName} /> : <span>{s.firstName?.charAt(0)}</span>}</div>
							<div className="sf-sdd-info">
								<span className="sf-sdd-name">
									{s.firstName} {s.lastName}
								</span>
								<span className="sf-sdd-sub">{s.slotsCount !== undefined ? slotsLabel(s.slotsCount) : s.role || ""}</span>
							</div>
							{selectedStaffId === s.staffId && <span className="sf-sdd-check">✓</span>}
						</div>
					))}
				</div>
			)}
		</div>
	);
};

export default StaffDropdown;
